import { Button, Modal, ModalFooter, Row } from '@amzn/meridian';
import { StopNavigationAway } from 'components/StopNavigationAway';
import type { FC } from 'react';
import { classes } from 'typestyle';
import { atfButtonStyles } from '../styles/styles';
import { useUploadAtfContext } from '../UploadAtfContext';
import { UploadAtfErrorModal } from './UploadAtfErrorModal';
import { UploadAtfLoadingModal } from './UploadAtfLoadingModal';
import { UploadAtfMixedSuccessModal } from './UploadAtfMixedSuccessModal';
import { UploadAtfSuccessModal } from './UploadAtfSuccessModal';

export const UploadAtfModal: FC = () => {
  const { cancelUpload, fileUploaded, openModal, enableStopNavigation, uploadResultTransform, job, bulkPublishJobList } =
    useUploadAtfContext();
  return (
    <>
      <Modal
        aria-describedby="bulk-atf-upload-modal"
        open={openModal}
        scrollContainer="viewport"
        title="Upload attributes and pricing values"
      >
        {fileUploaded &&
          uploadResultTransform &&
          uploadResultTransform.totalRowCount === uploadResultTransform.totalSuccesses &&
          uploadResultTransform.totalRowCount > 0 && (
            <UploadAtfSuccessModal
              bulkPublishJobList={bulkPublishJobList}
              jobId={job.id}
              successfullRows={uploadResultTransform.totalSuccesses}
            />
          )}
        {fileUploaded &&
          uploadResultTransform &&
          uploadResultTransform.totalRowCount === uploadResultTransform.totalSuccesses &&
          uploadResultTransform.totalRowCount === 0 && <UploadAtfErrorModal />}
        {fileUploaded && uploadResultTransform && uploadResultTransform.totalRowCount !== uploadResultTransform.totalSuccesses && (
          <UploadAtfMixedSuccessModal />
        )}
        {!fileUploaded && <UploadAtfLoadingModal />}
        <ModalFooter>
          <Row alignmentHorizontal="end" spacingInset="200 200 200 400" widths="fit">
            {fileUploaded && (
              <div>
                <Button className={classes(atfButtonStyles.anotherFileButton)} onClick={cancelUpload} size="small" type="primary">
                  Upload another file
                </Button>
                <Button onClick={cancelUpload} size="small" type="primary">
                  Done
                </Button>
              </div>
            )}
          </Row>
        </ModalFooter>
      </Modal>
      <StopNavigationAway
        cancelButtonText="Stay in page"
        confirmButtonText="Exit page"
        enableStopNavigation={enableStopNavigation}
        message="You are about to abandon this page while a file is being uploaded.
                The upload will continue in the background, but the results of the upload (including error messages) will not be displayed. "
        title="Are you sure you want to exit this page?"
      />
    </>
  );
};
